import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { inject, observer } from 'mobx-react/index';
import debounce from 'lodash/debounce';

class InvertingColorsBlock extends React.Component {
  static propTypes = {
    themeStore: PropTypes.object.isRequired,
    shouldInvert: PropTypes.bool,
    noFirstCall: PropTypes.bool,
  };

  firstCall = true;

  state = {
    minTopValue: 0,
  };

  componentDidMount() {
    this.updateValues();
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  resizeHandler = debounce(() => this.updateValues(), 200);

  componentInViewport = isVisible => {
    if (!this.props.shouldInvert) {
      return;
    }

    if (this.firstCall) {
      this.firstCall = false;
      if (this.props.noFirstCall) {
        return;
      }
    }

    if (isVisible) {
      this.props.themeStore.setInvertingBlockInViewport(true);
    } else {
      this.props.themeStore.setInvertingBlockInViewport(false);
    }
  };

  updateValues() {
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    this.setState({ minTopValue: viewportHeight - 100 });
  }

  render() {
    const { children } = this.props;

    return (
      <VisibilitySensor
        offset={{ top: 100 }}
        minTopValue={this.state.minTopValue}
        onChange={this.componentInViewport}
        partialVisibility
      >
        {children}
      </VisibilitySensor>
    );
  }
}

export default inject(stores => ({
  themeStore: stores.store.theme,
}))(observer(InvertingColorsBlock));



// WEBPACK FOOTER //
// ./src/components/InvertingColorsBlock.js